// Utilities
import { createSimpleFunctional } from '@/util'

export const VBannerText = createSimpleFunctional('v-banner-text')

export type VBannerText = InstanceType<typeof VBannerText>
